import PropTypes from 'prop-types';
import CallToAction from 'components/Common/CallToAction';
import { CustomYoutubePlayer } from 'components/Common/CustomYoutubePlayer';
import CallToActionNew from 'UI/components/CallToAction';
import BookmarkContainer from 'UI/containers/BookmarkContainer';
import { LINK_TYPE } from 'utils/constants/linkType';
import { getVideoIdFromEntry } from 'utils/microdata/videoUtils';
import styles from './ArticleLink.module.scss';

export const ArticleLink = ({
  data,
  new: isNew,
  type,
  title,
  buttonTitle,
  slug,
  url,
  className,
}) => {
  switch (type) {
  case LINK_TYPE.bookmark:
    return title && (url || slug) && (
      <BookmarkContainer
        title={title}
        url={url || slug}
        buttonTitle={buttonTitle}
      />
    );

  case LINK_TYPE.youTube: {
    const videoId = getVideoIdFromEntry(data);

    return videoId && (
      <CustomYoutubePlayer
        src={videoId}
        className={className}
        isArticle
      />
    );
  }

  default:
    if (isNew) {
      return (
        <CallToActionNew
          data={data}
          className={styles.cta}
        />
      );
    }

    return (
      <CallToAction
        title={title}
        buttonTitle={buttonTitle}
        href={slug}
        type="blog"
      />
    );
  }
};

ArticleLink.defaultProps = {
  type: '',
  title: '',
  buttonTitle: '',
  slug: '',
  url: '',
  className: '',
};

ArticleLink.propType = {
  type: PropTypes.string,
  title: PropTypes.string,
  buttonTitle: PropTypes.string,
  slug: PropTypes.string,
  url: PropTypes.string,
  className: PropTypes.string,
};
